import { ChangeDetectorRef, Component } from '@angular/core';
import { DynamicContentService } from '../../services/dynamic-content/dynamic-content.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Observable, Subject } from 'rxjs';
import { IWalletLoginRequest } from 'src/app/core/wallets/walletHandler.service';

@Component({
    selector: 'app-abstract-login',
    templateUrl: './abstract-login.component.html',
    styleUrls: ['./abstract-login.component.scss'],
    animations: [
        trigger('fadeIn', [
            state('void', style({ opacity: 0 })),
            transition(':enter', [
                animate('300ms')
            ]),
            transition(':leave', [
                animate('150ms')
            ])
        ]),
    ],
    standalone: false
})
export class AbstractLoginComponent {
    private _closeSubject: Subject<IWalletLoginRequest['response']> = new Subject();
    private _iframe: HTMLIFrameElement;

    loading = true;

    constructor(
        private dynamicContentService: DynamicContentService,
        private ref: ChangeDetectorRef,
    ) { }

    getCloseObservable(): Observable<IWalletLoginRequest['response']> {
        return this._closeSubject.asObservable();
    }

    initIframe(url: string): void {
        this._iframe = (document.getElementById('abstractIframe') as HTMLIFrameElement);
        this._iframe.src = url;
        this._iframe.addEventListener('load' ,() => {
            this.loading = false;
            this.ref.detectChanges();
        });
        this.ref.detectChanges();
    }

    closeAbstractLogin() {
        this.dynamicContentService.closeAbstractLogin();
        this._closeSubject.next({
            success: false,
            reason: 'Popup was closed by the user before finalizing the authentication. Please try again.'
        });
        this._iframe.removeAllListeners();
    }
}